<div class="d-flex flex-column gap-4">
  <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap">
    <h3 class="m-0 fw-semibold">Miscellaneous Documents</h3>
    @if (effectiveDealId() && canWriteDeals()) {
      <button type="button" class="btn btn-primary btn-h35" (click)="openGenerateDocumentModal()">
        <i class="bi bi-plus-lg lh-1"></i>
        Generate Document
      </button>
    }
  </div>

  @if (documents().length > 0) {
    <lib-signable-document-card
      signingContext="misc"
      [documents]="documents()"
      (refreshRequested)="reloadData()"
    ></lib-signable-document-card>
  } @else {
    <div class="border rounded-4 p-4 bg-light text-muted">
      No generated miscellaneous documents yet. Use Generate Document to create one.
    </div>
  }
</div>

<ng-template #generateDocumentModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between align-items-center">
      <h1 class="modal-title">Generate Document</h1>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>

    <div class="modal-body p-4 pt-0">
      <div class="mb-3">
        <label class="form-label">Document Type</label>
        <generic-dropdown
          placeholder="Select document type"
          [items]="createTypeDropdownItems()"
          [required]="true"
          errormessage="Document type is required"
          [value]="selectedCreateType()"
          (valueChange)="onCreateTypeChange($event)"
        ></generic-dropdown>
      </div>

      @switch (selectedCreateType()) {
        @case ('coop') {
          @if (templatesForGeneration().length > 0) {
            <lib-doc-generation
              generationContext="misc"
              [dealId]="effectiveDealId()"
              [projectId]="projectId()"
              [contractDetails]="contractDetails()"
              [documentTemplatesInput]="templatesForGeneration()"
              (refreshRequested)="onDocumentGenerated(modal)"
            ></lib-doc-generation>
          } @else {
            <div class="text-muted">All COOP templates for this deal have already been generated.</div>
          }
        }
        @case ('amendment') {
          <lib-amendment-document
            [dealId]="effectiveDealId()"
            [sequenceNumber]="nextAmendmentSequence()"
            (refreshRequested)="reloadData()"
            (documentGenerated)="onDocumentGenerated(modal)"
          ></lib-amendment-document>
        }
        @case ('custom') {
          <lib-custom-document
            [dealId]="effectiveDealId()"
            (refreshRequested)="reloadData()"
            (documentGenerated)="onDocumentGenerated(modal)"
          ></lib-custom-document>
        }
      }
    </div>

    <!-- <div class="modal-footer">
      <button type="button" class="btn btn-shadow" (click)="modal.dismiss('Close')">Close</button>
    </div> -->
  </div>
</ng-template>
